export default [
  {
    path: "/sign-in",
    name: "Login",
    meta: {
      layout: "empty",
      public: true,
    },
    component: () => import("@/modules/Authorization/pages/PLogin.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    meta: {
      layout: "empty",
      public: true,
    },
    component: () => import("@/modules/Authorization/pages/PResetPassword.vue"),
  },
  // There is no self-registration: accounts come from an admission application or a signed
  // contract, so /sign-up only ever sends people back to the login page.
  {
    path: "/sign-up",
    redirect: "/sign-in",
  },
  {
    path: "/:slug",
    name: "AuthPolicy",
    meta: {
      layout: "empty",
      public: true,
    },
    component: () => import("@/modules/Authorization/pages/PPolicy.vue"),
  },
];
